
const MainCategory = ['Wybierz', 'Mieszkanie', 'Dom','Działka', 'Biuro', 'Lokal', 'Magazyn', 'Garaż']

export default MainCategory;
